<!--  -->
<template>
  <div>
    <el-input v-model="objr.keyword" style="width:200px;margin-bottom:10px" placeholder="请输入内容" />
    <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="sraw">搜索</el-button>
    <el-button type="primary" @click="awered">重置</el-button>
    <el-table
      ref="table"
      :key="refreshKey"
      v-loading="loading"
      :data="publicAdvertListr"
      border
      style="width: 100%"
    >
      <!-- <el-table-column
        align="center"
        label="选项"
        width="100"
      >
        <template slot-scope="scope">
          <input
            v-model="scope.row.checkboxFlag"
            type="checkbox"
            @click="handleChangeSelectone(scope.$index, scope.row)"
          >
          {{ scope.row.$index }}
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="platformIdStr"
        label="平台名称"
        width="100px"
      />
      <el-table-column
        align="center"
        prop="accountName"
        label="公众号名称"
      />

      <el-table-column
        align="center"
        prop="appId"
        label="appId"
      />
      <el-table-column
        align="center"
        prop="ghId"
        label="gh_id"
      />

      <el-table-column
        align="center"
        label="操作"
        width="100"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="chooserr(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>
</template>

<script>
import { officialaccountlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      input: '',
      objr: {
        page: 1,
        pageSize: 10,
        keyword: null,
        platformId: ''
      },
      refreshKey: 0,
      loading: false,
      publicAdvertListr: [],
      newtotalr: null

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    // 获取客服消息
    menuList() {
      this.loading = true
      officialaccountlist(this.objr).then(res => {
        this.publicAdvertListr = this.convertToHump(res.data.list)
        console.log('res.data.list', this.publicAdvertListr)
        this.loading = false
        // this.publicAdvertListr.forEach(item => {
        //   // item.checkboxFlag = false
        //   this.$set(item, 'checkboxFlag', false)
        //   if (item.customerMessageNo === this.kefuid) {
        //     item.checkboxFlag = true
        //   }
        // })
        this.newtotalr = res.data.total
      })
    },
    sraw() {
      this.objr.page = 1
      this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.pageSize = 10
      this.objr.keyword = null
      this.menuList()
    },
    send(val) {
      console.log('val1111', val)
      this.objr.platformId = val
      this.menuList()
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    handleChangeSelectone(index) {
      console.log(this.publicAdvertListr[index])
      if (!this.publicAdvertListr[index].checkboxFlag) {
        console.log('item', this.publicAdvertListr[index])
        this.$emit('callback', this.publicAdvertListr[index].customerMessageNo)
      } else {
        // this.selectData = null
      }
      this.publicAdvertListr.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvertListr[index].checkboxFlag = true
    },
    chooserr(item) {
      this.$emit('callback', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
